import React from 'react'

import { Form } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablasComunesService from 'services/tablasComunes.service'

const OrigenFormGroup = ({ ...props }) => {
  const [origenes, setOrigenes] = React.useState([])

  React.useEffect(() => {
    TablasComunesService.getAsSelect(TiposTablaComunConstant.ORIGENES).then(({ data }) => {
      setOrigenes(data)
    })
  }, [])

  return (
    <Form.Select {...props}>
      <option value=''>Seleccionar</option>
      {origenes.map((x, k) => (
        <option key={k} value={x._id}>
          {x.nombre}
        </option>
      ))}
    </Form.Select>
  )
}

export default React.memo(OrigenFormGroup)
